module.exports = __webpack_public_path__ + "img/组 129@2x(1).f0c832d0.png";